module.exports = __webpack_public_path__ + "img/create-new.d8eac5cc.svg";